let pop4KsPopupIndex = null
let hasSubmitted = false

window.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded')

  bannerOffIcon()

  if(window.location.pathname.includes('/pages/pop4-ks-gg')) {
    liangxingGtmInit()
  }

  const closePop4Ks = document.querySelector('.PKSL--banner-close')
  closePop4Ks.addEventListener('click', () => {
    if(pop4KsPopupIndex) {
      layer.close(pop4KsPopupIndex)
    }
  })

  if(localStorage.getItem('Pop4KsJoined') === '1') {
    return
  }

  const targetEl = document.querySelector("[id*='__vbot_rich_text_WpbhdG']")

  // 监听滚动到目标元素时，执行回调
  const ksObserver = new IntersectionObserver((entries, observer) => {
    const _submited = localStorage.getItem('Pop4KsJoined')
    for(const entry of entries) {
      if(entry.isIntersecting && _submited !== '1') {
        console.log('entry.isIntersecting， 弹窗')
        document.body.style.overflow = 'hidden'
        togglePop4Ks()
      }
    }
  }, {
    threshold: 1
  })
  ksObserver.observe(targetEl)
})

function togglePop4Ks() {
  // 在此处输入 layer 的任意代码
  pop4KsPopupIndex = layer.open({
    type: 1, // page 层类型
    id: "pop4KsPopUp",
    area: ['auto', 'auto'],
    title: false,
    shade: 0.3, // 遮罩透明度
    shadeClose: true, // 点击遮罩区域，关闭弹层
    anim: 0, // 0-6 的动画形式，-1 不开启
    content: $('#pop4-ks-layer-wrapper'), // 捕获的元素
    success: function(layero) {
      try {
        const rootEl = layero && layero[0]
        if (rootEl) {
          rootEl.style.maxHeight = '720px'
          rootEl.style.overflow = 'hidden'
        }

        const contentEl = layero && layero[0] && layero[0].querySelector('.layui-layer-content')
        if (!contentEl) return

        // 让滚动发生在 content 区域，避免弹层外壳滚动导致底部“空一块”
        contentEl.style.overflowY = 'auto'
        contentEl.style.overflowX = 'hidden'
        contentEl.style.height = 'auto'
        contentEl.style.maxHeight = '720px'
        contentEl.style.webkitOverflowScrolling = 'touch'
      } catch (e) {}
    },
    // 用户触发关闭（点击遮罩/右上角 X 等）时
    cancel: function() {
      document.body.style.overflow = 'auto'
    },
    // 弹层关闭并完成清理后
    end: function() {
      document.body.style.overflow = 'auto'
    },
  });
}

// banner 加 图标
function bannerOffIcon () {
  const bannerEl = document.querySelector('.section-range-banner-container')

  const imgIcon = document.createElement('img')
  imgIcon.src =
    'https://cdn.shopify.com/s/files/1/0538/9533/2027/files/pop4-banner-off-30.png?v=1775130708'
  imgIcon.alt = 'pop4-ks-icon'
  imgIcon.classList.add('pop4-ks-banner-off-icon')
  bannerEl.appendChild(imgIcon)
}

document.addEventListener('globo.formbuilder.form.submitted', e => {
  const cfg = {
    first: {
      sectionID: '__vbot_rich_text_EEKfjN',
      toHideElements: ['.rich-text__text.p-20-14 p', '.PKSL--content-title'],
    },
    second: {
      sectionID: '__vbot_rich_text_AWwedb',
      toHideElements: ['.rich-text__heading.title-48-24', '.rich-text__text'],
    }
  }
  try {
    const parent = e.detail.form.closest('[id*="__vbot_rich_text_"]')
    // console.log(`%c>> $***`, 'color:yellow', parent, parent.id)

    // 判断parent是 first 还是 second， 隐藏对应的toHideElements
    let section;
    if (parent.id.includes(cfg.first.sectionID)) {
      section = cfg.first
    } else if (parent.id.includes(cfg.second.sectionID)) {
      section = cfg.second
    }
    // console.log(`%c>> $***999`, 'color:yellow', section)
    if (section) {
      section.toHideElements.forEach(selector => {
        const el = parent.querySelectorAll(selector)
        if (el.length > 0) {
          el.forEach(item => {
            item.style.display = 'none'
          })
        }
      })
    }
    gtnSend()
    localStorage.setItem('Pop4KsJoined', '1')
  } catch (error) {
    console.log('error', error)
  }
})


// @xinyu 0407
function xinYuFeishuGtm() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'lead_form_submit',
  })

  fbq('track', 'CompleteRegistration') 
}

// @lianging 0407
function liangxingGtmInit() {
  //   <!-- Google tag (gtag.js) -->
  const sc = document.createElement('script')
  sc.src = 'https://www.googletagmanager.com/gtag/js?id=AW-10924456455'
  sc.async = true
  document.body.appendChild(sc)
}

function liangxingGtmSend() {
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'AW-10924456455');
}

function gtnSend() {
  if(window.location.pathname.includes('/pages/pop4-ks-gg')) {
    liangxingGtmSend()
  } else if(window.location.pathname.includes('/pages/pop4-ks-fb') || window.location.pathname.includes('/pages/pop4-ks-rd')) {
    xinYuFeishuGtm()
  }
}
